export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: 'TC面料采购单号',
    field: 'tcFabricPurchaseNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '订单编号',
    field: 'orderNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '业务人员',
    field: 'salesPersonName',
    width: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '供应商',
    field: 'scmName',
    width: 220,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '采购方',
    field: 'buyScmName',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '采购日期',
    field: 'tcPurchaseDate',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: 'TC面料金额',
    field: 'v_fabricAmount',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '附加费用',
    field: 'v_surcharge',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '金额合计',
    field: 'v_totalAmount',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '备注说明',
    field: 'remark',
    width: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_name') || '审核人',
    field: 'reviewByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_time') || '审核时间',
    field: 'reviewTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
